import { render, staticRenderFns } from "./message-template.vue?vue&type=template&id=2d08d203&scoped=true"
import script from "./message-template.vue?vue&type=script&lang=ts"
export * from "./message-template.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08d203",
  null
  
)

export default component.exports